import React from 'react';

const Pagination = ({ elementPerPage, totalElements, paginate, currentPage, prevPage, nextPage }) => {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalElements / elementPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <>
      <nav aria-label="Page navigation">
        <ul className="pagination justify-content-end align-items-center">
          <li className="caption">Scorri pagine</li>
          {currentPage > 1 ? <li className="page-item" onClick={() => prevPage(currentPage)}><p className="page-link prev" >Previous</p></li> : <li className="page-item disabled"><p className="page-link prev" >Previous</p></li>}
          <li className="page-item"><span className="current-page">{currentPage}/{pageNumbers.length}</span></li>
          
          {currentPage < pageNumbers[pageNumbers.length - 1] ? <li className="page-item" onClick={() => nextPage(currentPage)}><p className="page-link next" >Next</p></li> : <li className="page-item disabled"><p className="page-link next" >Next</p></li>}
        </ul>
      </nav>
      {/* <nav>
      <ul className='pagination'>
        {pageNumbers.map(number => (
          <li key={number} className='page-item'>
            <a onClick={() => paginate(number)} href='/#'className='page-link'>
              {number}
            </a>
          </li>
        ))}
      </ul>
    </nav> */}
      </>
  );
};

export default Pagination;